module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<img src="' +
__e( src ) +
'" alt="' +
__e( alt ) +
'" width="32" height="32" onerror="this.style.opacity=\'0\'">\n<p>' +
((__t = ( boldProductName )) == null ? '' : __t) +
'</p>\n';

}
return __p
}